import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { withCustomerOrdersItem } from "./withCustomerOrdersItem"
import { Accordion } from "../../../Accordion/Accordion"
import { Icon } from "../../../Icon/Icon"
import { Price } from "../../../Price/Price"
import ImageCTA from "../../../Image/ImageCTA"
import { StyledP } from "../../../Styled/Text"

const styles = {
  column: {
    widths: {
      "w-full": tw`w-full`,
      "w-1/8": tw`w-1/8`,
      "w-1/4": tw`w-1/4`,
    },
    fixed: {
      "w-1/8": tw`min-w-5 md:min-w-8`,
    },
  },
}

const Desktop = tw.div`hidden md:block`
const Mobile = tw.div`block md:hidden`
const Wrapper = tw.div`pb-2`
const WrapperMobile = tw.div`flex flex-col w-full`
const StyledRow = tw.div`flex w-full items-start flex-wrap`
const StyledColumn = styled.div`
  ${tw`text-left`}
  ${({ width }) => (width && styles.column.widths[width] ? styles.column.widths[width] : null)}
  ${({ fixed }) => (fixed && styles.column.fixed[fixed] ? styles.column.fixed[fixed] : null)}
`
const Label = tw.div`uppercase` // styledsmall
const ImageWrapper = tw.div`relative w-8 min-w-8 h-8 min-h-8 md:w-8 md:min-w-8 md:h-8`
const ImageWrapperInner = tw.div`relative w-full h-full overflow-hidden`
const Content = tw.div`flex flex-col max-w-4/5`
const HeaderTitle = tw(StyledP)`capitalize`
const Title = tw(StyledP)`mr-1 mb-1 capitalize`
// const Title = tw(StyledP)`mr-1 mb-1 text-14 capitalize` // font chnage
const PriceWrapper = tw.div`mr-1 mb-1 text-10 inline-block md:block` // styledsmall
const Subtitle = tw.p`mr-1 mb-1 text-14 md:text-14`
const Button = styled.button`
  ${tw`focus:outline-none md:pb-0-8 text-left`}
  & p {
    ${tw`pb-2`}
  }
`
const ButtonText = tw.div`underline uppercase` // styledsmall
const MobileField = tw.div`flex flex-row mb-2-4`
const MobileFieldLabelWrapper = tw.div`w-5/12`
const MobileFieldContentWrapper = tw.div`w-7/12`
const MobileFieldLabel = tw.div`flex items-center text-14 uppercase` // styledsmall
const MobileFieldLabelSpan = tw.span`text-14 ml-1`
const MobileFieldContent = tw(StyledP)`capitalize`
// const MobileFieldContent = tw(StyledP)`text-18 capitalize` // font chnage

export const CustomerOrdersItem = withCustomerOrdersItem(
  ({
    order,
    handleOrderAgain,
    cartLoading,
    additionalOrderNo,
    additionalDate,
    additionalStatus,
    additionalTotalPrice,
    additionalMore,
    additionalTracking,
    additionalOrderAgain,
  }): JSX.Element => {
    const { name, price, fulfillmentStatus, url, date, lineItems } = order
    const buildDesktopTitleElement = active => (
      <StyledRow>
        <StyledColumn width={"w-1/8"} fixed={`w-1/8`}>
          <HeaderTitle>{name}</HeaderTitle>
        </StyledColumn>
        <StyledColumn width={"w-1/4"}>
          <HeaderTitle>{date}</HeaderTitle>
        </StyledColumn>
        <StyledColumn width={"w-1/4"}>
          <HeaderTitle>{fulfillmentStatus}</HeaderTitle>
        </StyledColumn>
        <StyledColumn width={"w-1/4"}>
          <HeaderTitle>{price}</HeaderTitle>
        </StyledColumn>
        <StyledColumn width={"w-1/8"}>
          <HeaderTitle>{!active ? <Icon name={`plus`} size={10} /> : <Icon name={`cross`} size={10} />}</HeaderTitle>
        </StyledColumn>
      </StyledRow>
    )

    const buildMobileTitleElement = active => (
      <StyledColumn width={"w-full"}>
        <MobileField>
          <MobileFieldLabelWrapper>
            <MobileFieldLabel className="body_small_highlight">{additionalOrderNo}</MobileFieldLabel>
          </MobileFieldLabelWrapper>
          <MobileFieldContentWrapper>
            <MobileFieldContent>{name}</MobileFieldContent>
          </MobileFieldContentWrapper>
        </MobileField>
        <MobileField>
          <MobileFieldLabelWrapper>
            <MobileFieldLabel className="body_small_highlight">{additionalDate}</MobileFieldLabel>
          </MobileFieldLabelWrapper>
          <MobileFieldContentWrapper>
            <MobileFieldContent>{date}</MobileFieldContent>
          </MobileFieldContentWrapper>
        </MobileField>
        <MobileField>
          <MobileFieldLabelWrapper>
            <MobileFieldLabel className="body_small_highlight">{additionalStatus}</MobileFieldLabel>
          </MobileFieldLabelWrapper>
          <MobileFieldContentWrapper>
            <MobileFieldContent>{fulfillmentStatus}</MobileFieldContent>
          </MobileFieldContentWrapper>
        </MobileField>
        <MobileField>
          <MobileFieldLabelWrapper>
            <MobileFieldLabel className="body_small_highlight">{additionalTotalPrice}</MobileFieldLabel>
          </MobileFieldLabelWrapper>
          <MobileFieldContentWrapper>
            <MobileFieldContent>{price}</MobileFieldContent>
          </MobileFieldContentWrapper>
        </MobileField>
        <MobileField>
          <MobileFieldLabelWrapper>
            <MobileFieldLabel className="body_small_highlight">
              {additionalMore}
              <MobileFieldLabelSpan>{!active ? <Icon name={`plus`} size={10} /> : <Icon name={`cross`} size={10} />}</MobileFieldLabelSpan>
            </MobileFieldLabel>
          </MobileFieldLabelWrapper>
        </MobileField>
      </StyledColumn>
    )

    return (
      <>
        <Desktop>
          <Accordion size={`account`} titleElement={buildDesktopTitleElement}>
            {lineItems?.map((lineItem, index) => {
              return (
                <Wrapper key={index}>
                  <StyledRow>
                    <StyledColumn width={"w-1/8"} fixed={`w-1/8`}>
                      <ImageWrapper>
                        <ImageWrapperInner>
                          <ImageCTA image={lineItem?.variant?.image?.originalSrc} objectFit={`fill`} />
                        </ImageWrapperInner>
                      </ImageWrapper>
                    </StyledColumn>
                    <StyledColumn width={"w-1/4"}>
                      <Content>
                        <Title>{lineItem?.title}</Title>
                        {lineItem?.variant?.title && lineItem.variant.title.toLowerCase() !== "default title" && (
                          <Subtitle>{lineItem?.variant?.title}</Subtitle>
                        )}
                        <PriceWrapper className="body_small_highlight">
                          <Price price={lineItem?.discountedTotalPrice} layout={`product`} />
                        </PriceWrapper>
                      </Content>
                    </StyledColumn>
                    <StyledColumn width={"w-1/4"}>
                      {index === 0 ? (
                        <Content>
                          <Button as={"a"} href={url} aria-label={additionalTracking}>
                            <ButtonText className="body_small_highlight">{additionalTracking}</ButtonText>
                          </Button>
                          <Button onClick={handleOrderAgain} disabled={cartLoading}>
                            <ButtonText className="body_small_highlight">{cartLoading ? `Adding...` : additionalOrderAgain}</ButtonText>
                          </Button>
                        </Content>
                      ) : null}
                    </StyledColumn>
                    <StyledColumn width={"w-1/4"}>
                      <Label className="body_small_highlight" />
                    </StyledColumn>
                    <StyledColumn width={"w-1/8"}>
                      <Label className="body_small_highlight" />
                    </StyledColumn>
                  </StyledRow>
                </Wrapper>
              )
            })}
          </Accordion>
        </Desktop>
        <Mobile>
          <Accordion size={`accountMobile`} titleElement={buildMobileTitleElement}>
            <WrapperMobile>
              {lineItems?.map((lineItem, index) => {
                return (
                  <StyledColumn width={"w-full"} key={index}>
                    <MobileField>
                      <MobileFieldLabelWrapper>
                        <ImageWrapper>
                          <ImageWrapperInner>
                            <ImageCTA image={lineItem?.variant?.image?.originalSrc} objectFit={`fill`} />
                          </ImageWrapperInner>
                        </ImageWrapper>
                      </MobileFieldLabelWrapper>
                      <MobileFieldContentWrapper>
                        <Title>{lineItem?.title}</Title>
                        {lineItem?.variant?.title && lineItem.variant.title.toLowerCase() !== "default title" && (
                          <Subtitle>{lineItem?.variant?.title}</Subtitle>
                        )}
                        <PriceWrapper className="body_small_highlight">
                          <Price price={lineItem?.discountedTotalPrice} layout={`product`} />
                        </PriceWrapper>
                      </MobileFieldContentWrapper>
                    </MobileField>
                  </StyledColumn>
                )
              })}
              <StyledColumn width={"w-full"}>
                <MobileField>
                  <MobileFieldLabelWrapper>
                    <Button as={"a"} href={url} aria-label={additionalTracking}>
                      <ButtonText className="body_small_highlight">{additionalTracking}</ButtonText>
                    </Button>

                    <Button onClick={handleOrderAgain} disabled={cartLoading}>
                      <ButtonText className="body_small_highlight">{cartLoading ? `Adding...` : additionalOrderAgain}</ButtonText>
                    </Button>
                  </MobileFieldLabelWrapper>
                </MobileField>
              </StyledColumn>
            </WrapperMobile>
          </Accordion>
        </Mobile>
      </>
    )
  }
)
